<template>
  <div>
    <el-card>
      <el-row>
        <el-col>
          <el-date-picker
            v-model="starttime"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>

          <el-button
            type="goon"
            style="margin-left: 20px"
            @click="GetHe_FoodPersonList"
            >查询</el-button
          >
        </el-col>
      </el-row>
    </el-card>
    <el-card style="margin-top: 20px">
      <el-button type="goon" style="margin-right: 35px" @click="onClickAdd"
        >上报今日人数</el-button
      >
    </el-card>
    <el-card style="margin-top: 20px">
      <el-table
        :data="tableData"
        style="width: 100%"
        :header-cell-style="{
          background: '#F2F5FF',
          color: '#333',
          'text-align': 'center',
        }"
        border
      >
        <el-table-column
          prop="ReportDateString"
          label="应上报日期"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="ActualTimeString"
          label="上报时间"
          align="center"
        >
        </el-table-column>
        <el-table-column prop="Reporter" label="上报人" align="center">
        </el-table-column>
        <el-table-column prop="Status" label="状态" align="center">
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button
              type="text"
              style="color: #4083fe"
              @click="onEditRow(scope.row)"
              >编辑</el-button
            >
            <el-button
              type="text"
              @click="onClickDelete(scope.row)"
              style="color: #e14747"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="PageIndex"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="PageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        style="text-align: center;padding:20px; 0 0 0"
      >
      </el-pagination>
      <!-- <el-pagination
        layout="prev, pager, next"
        @current-change="handleCurrentChange"
        :page-size="PageSize"
        :total="total"
        style="text-align: center;padding:20px; 0 0 0"
      >
      </el-pagination> -->
    </el-card>
    <el-dialog :title="Title" :visible.sync="dialogVisible" width="50%">
      <div>
        <el-form
          :model="ruleForm"
          ref="ruleForm"
          class="demo-ruleForm"
          label-position="top"
        >
          <el-form-item>
            <el-date-picker
              v-model="ruleForm.date"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
            >
            </el-date-picker>
          </el-form-item>
        </el-form>
        <el-table
          :data="addTableData"
          style="width: 100%; margin-top: 20px"
          :header-cell-style="{ background: '#F2F5FF', color: '#333' }"
          border
        >
          <el-table-column prop="className" label="班级"> </el-table-column>
          <el-table-column prop="classNumber" label="班级人数" width="80">
          </el-table-column>
          <el-table-column label="出勤人数">
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.attendanceNumber"
                placeholder="请输入内容"
                @input="onChangeInput($event, scope.row)"
                type="number"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column label="早点就餐人数">
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.breakfastNumber"
                placeholder="请输入内容"
                type="number"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column label="午餐就餐人数">
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.lunchNumber"
                placeholder="请输入内容"
                type="number"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column label="午点就餐人数">
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.afternoonNumber"
                placeholder="请输入内容"
                type="number"
              ></el-input>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="Title == '新增' ? addSubmit() : editSubmit()"
          >提 交</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  GetHe_FoodPersonList,
  GetClassDetailInfoList,
  AddHe_FoodPerson,
  GetHe_FoodPersonDetailList,
  UpdateHe_FoodPerson,
  DelHe_FoodPerson,
} from "../../../api/api";
import {
  getWeekStartDate,
  getWeekEndDateFive,
} from "../../../../util/otherRenders";

import moment from "moment";

export default {
  data() {
    return {
      starttime: [],
      tableData: [],
      addTableData: [],
      PageSize: 10,
      PageIndex: 1,
      total: 0,
      dialogVisible: false,
      Title: "",
      ruleForm: {
        date: "",
      },
      userInfo: {},
      Reporter: "",
      SchoolId: 0,
      Id: 0,
      value1: "",
    };
  },
  async created() {
    this.userInfo = JSON.parse(window.localStorage.user);

    // await this.getNowTime();
    this.getWeekDate();
    this.addGetNowTime();
    await this.GetHe_FoodPersonList();
  },
  methods: {
    onChangeInput(e, item) {
      item.afternoonNumber = Number(item.attendanceNumber);
      item.breakfastNumber = Number(item.attendanceNumber);
      item.lunchNumber = Number(item.attendanceNumber);
    },
    getWeekDate() {
      // 第一步: 获取今天是本周的第几天
      const weekOfday = moment().format("E");
      // 第二步: 获取本周周一的日期
      const lastMonday = moment()
        .subtract(weekOfday - 1, "days")
        .format("yyyy-MM-DD");
      // 第三步: 获取本周周末的日期
      const lastSunday = moment()
        .add(5 - weekOfday, "days")
        .format("yyyy-MM-DD");
      console.log(lastMonday, lastSunday, "日期");
      this.starttime.push(lastMonday);
      this.starttime.push(lastSunday);
    },
    // 删除
    async onClickDelete(item) {
      this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        let res = await DelHe_FoodPerson({ ids: [item.Id] });
        if (res.data.success) {
          this.$message({
            type: "success",
            message: "删除成功!",
          });
          this.GetHe_FoodPersonList();
        } else {
          this.$message({
            type: "error",
            message: "删除失败!",
          });
        }
      });
    },
    // 编辑
    async onEditRow(row) {
      this.Title = "编辑";
      this.SchoolId = row.SchoolId;
      this.Reporter = row.Reporter;
      this.ruleForm.date = row.ReportDateString;
      this.Id = row.Id;
      let res = await GetHe_FoodPersonDetailList({ He_FoodPersonId: row.Id });
      if (res.data.success) {
        this.addTableData = res.data.response.map((item) => {
          return {
            attendanceNumber: Number(item.AttendanceNumber),
            breakfastNumber: Number(item.BreakfastNumber),
            lunchNumber: Number(item.LunchNumber),
            afternoonNumber: Number(item.AfternoonNumber),
            classId: item.ClassId,
            className: item.ClassName,
            classNumber: item.ClassNumber,
            foodPersonDetailId: item.Id,
          };
        });
        this.dialogVisible = true;
      } else {
        this.$message({
          type: "error",
          message: res.data.msg,
        });
      }
    },
    // 编辑确定
    async editSubmit() {
      const params = {
        Id: this.Id,
        reportDateString: this.ruleForm.date,
        SchoolId: this.SchoolId,
        reporter: this.Reporter,
        foodPersonDetailList: this.addTableData,
      };
      let res = await UpdateHe_FoodPerson(params);
      if (res.data.success) {
        this.$message({
          type: "success",
          message: res.data.msg,
        });
        this.dialogVisible = false;
        await this.GetHe_FoodPersonList();
      } else {
        this.$message({
          type: "error",
          message: res.data.msg,
        });
      }
    },
    // 新增
    async addSubmit() {
      const params = {
        reportDateString: this.ruleForm.date,
        SchoolId: this.userInfo.SchoolId,
        reporter: this.userInfo.uRealName,
        foodPersonDetailList: this.addTableData,
      };
      let res = await AddHe_FoodPerson(params);
      if (res.data.success) {
        this.$message({
          type: "success",
          message: res.data.msg,
        });
        this.dialogVisible = false;
        await this.GetHe_FoodPersonList();
      } else {
        this.$message({
          type: "error",
          message: res.data.msg,
        });
      }
    },
    async GetHe_FoodPersonList() {
      const params = {
        Id: this.userInfo.SchoolId,
        StartDate: this.starttime[0],
        EndDate: this.starttime[1],
        PageIndex: this.PageIndex,
        PageSize: this.PageSize,
      };
      let res = await GetHe_FoodPersonList(params);
      if (res.data.success) {
        this.tableData = res.data.response.data;
        this.total = res.data.response.dataCount;
        //console.log(this.tableData, "asdas");
      } else {
        this.tableData = [];
        this.total = 0;
      }
    },
    async getNowTime() {
      this.starttime.push(getWeekStartDate());
      this.starttime.push(getWeekEndDateFive());
    },
    addGetNowTime() {
      var now = new Date();
      var year = now.getFullYear(); //得到年份
      var month = now.getMonth(); //得到月份
      var date = now.getDate(); //得到日期
      month = month + 1;
      month = month.toString().padStart(2, "0");
      date = date.toString().padStart(2, "0");
      var defaultDate = `${year}-${month}-${date}`;
      this.$set(this.ruleForm, "date", defaultDate);
    },
    handleCurrentChange(val) {
      this.PageIndex = val;
      this.GetHe_FoodPersonList();
    },
    handleSizeChange(val) {
      this.PageSize = val;
      this.GetHe_FoodPersonList();
    },
    async onClickAdd() {
      let res = await GetClassDetailInfoList({
        SchoolId: this.userInfo.SchoolId,
      });
      if (res.data.success) {
        this.addTableData = res.data.response.map((item) => {
          return {
            attendanceNumber: Number(item.Number),
            breakfastNumber: Number(item.Number),
            lunchNumber: Number(item.Number),
            afternoonNumber: Number(item.Number),
            classId: item.Id,
            className: item.Name,
            classNumber: item.Number,
          };
        });
        //console.log(this.addTableData, "this.addTableData");
        this.Title = "新增";
        this.dialogVisible = true;
      } else {
        this.$message({
          type: "error",
          message: res.data.msg,
        });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.el-button--goon {
  color: #fff;
  background-color: #5474e6;
  border-color: #5474e6;
  height: 34px;
  line-height: 34px;
  padding: 0 20px;
}
</style>